export const SET_TEAM_DATA = "SET_TEAM_DATA";
const initialState = {
  show_add_team_modal: false,
  disable_team_add_btn: false,
  delete_team_member: null,
  del_btn_disable: false,
  team_logo_dlt: false,
  add_team_otp_popup: false,
  add_team_otp_resend_enable: true,
  add_team_otp: "",
  belongs_to: true,
  reporting_manager: "",
  resend_invitation_popup: false,
  org_resend_enable: true,
};

export default (state = initialState, action = {}) => {
  if (action.type == SET_TEAM_DATA) {
    return { ...state, ...action.payload };
  }
  return state;
};
